import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export const selectMyCognitoId = (state: RootState) => state.user.cognitoId;

export const selectMyConnectionsFeatureFlag = (state: RootState) => state.user.showConnectionsFeature;

// partnerType is ONLY used now to identify a parent - maybe we could use !!user.partnerCamhsChildren to do this?
export const selectIsParent = (state: RootState) => state.user.partnerType === 'PARENT';

export const selectIsUserLoaded = (state: RootState) => !!state.user.partnerType;

export const selectCamhsChildren = (state: RootState) => state.user.partnerCamhsChildren;

export const selectFirstCamhsChild = createSelector(selectCamhsChildren, (children) => children?.[0]);

export const selectDataShareConsent = (state: RootState) => state.user.partnerDataShareConsent;
